import { useEffect, useState } from 'react';
import { QuizResultEventDto, SavedQuizAnswersDto, UserQuizFilter, UserQuizOptionDto } from '../general/dtos';
import { useApi } from './api-provider';

export function useUserQuizOptions(sub: string) {
    const api = useApi();
    const [options, setOptions] = useState<UserQuizOptionDto[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;
        setOptions([]);
        setError(null);
        setLoading(false);
        if (!api || !sub) return;
        setLoading(true);
        api.getUserQuizOptions(sub)
            .then(result => { if (active) setOptions(result.data); })
            .catch(error => { if (active) setError(error.response?.data?.message ?? 'Failed to load quiz choices.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [api, sub]);

    return { options, loading, error };
}

export function useUserQuizResults(sub: string, filter: UserQuizFilter | null) {
    const api = useApi();
    const [events, setEvents] = useState<QuizResultEventDto[]>([]);
    const [savedAnswers, setSavedAnswers] = useState<SavedQuizAnswersDto[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const courseKey = filter?.course_key;
    const moduleKey = filter?.module_key;

    useEffect(() => {
        let active = true;
        setEvents([]);
        setSavedAnswers([]);
        setError(null);
        setLoading(false);
        if (!api || !sub || (!courseKey && !moduleKey)) return;
        setLoading(true);
        api.getUserQuizResults(sub, courseKey ? { course_key: courseKey } : { module_key: moduleKey! })
            .then(result => { if (active) { setEvents(result.data); setSavedAnswers(result.saved_answers ?? []); } })
            .catch(error => { if (active) setError(error.response?.data?.message ?? 'Failed to load quiz results.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [api, sub, courseKey, moduleKey]);

    return { events, savedAnswers, loading, error };
}
